const container = document.querySelector(".js-main-content");
const inlineRelated = document.querySelector("[data-inline-related]");

if (container && inlineRelated) {
  const firstParagraph = container.querySelectorAll(
    ".container--text > .text"
  )[0];
  const reference = firstParagraph
    ? firstParagraph.querySelectorAll("p")[0]
    : null;

  if (reference) {
    reference.parentNode.insertBefore(inlineRelated, reference.nextSibling);
  }
}
